function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useCallback, useEffect, useRef, useState } from "react";
import { recordKeys } from "@oui/lib/src/recordKeys";
var listeners = {}; // eslint-disable-line
function getStorageKey(key) {
    return "usePersistedState:".concat(key);
}
export function setPersistedState(key, value) {
    var _listeners_storageKey;
    var storageKey = getStorageKey(key);
    void AsyncStorage.setItem(storageKey, JSON.stringify(value));
    INITIAL_VALUES[key] = value;
    (_listeners_storageKey = listeners[storageKey]) === null || _listeners_storageKey === void 0 ? void 0 : _listeners_storageKey.forEach(function(cb) {
        return cb(value);
    });
}
var INITIAL_VALUES = {};
export function preloadPersistedState(key) {
    return _preloadPersistedState.apply(this, arguments);
}
function _preloadPersistedState() {
    _preloadPersistedState = _async_to_generator(function(key) {
        var persistedValue, decoded;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        AsyncStorage.getItem(getStorageKey(key))
                    ];
                case 1:
                    persistedValue = _state.sent();
                    if (persistedValue) {
                        decoded = typeof persistedValue === 'undefined' ? undefined : JSON.parse(persistedValue);
                        INITIAL_VALUES[key] = decoded;
                        return [
                            2,
                            decoded
                        ];
                    }
                    return [
                        2,
                        undefined
                    ];
            }
        });
    });
    return _preloadPersistedState.apply(this, arguments);
}
export function clearPersistedState() {
    return _clearPersistedState.apply(this, arguments);
}
function _clearPersistedState() {
    _clearPersistedState = _async_to_generator(function() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, _listeners_key, _;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = recordKeys(INITIAL_VALUES)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            key = _step.value;
                            ;
                            delete INITIAL_VALUES[key];
                            (_listeners_key = listeners[key]) === null || _listeners_key === void 0 ? void 0 : _listeners_key.forEach(function(cb) {
                                return cb(undefined);
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _ = AsyncStorage.multiRemove;
                    return [
                        4,
                        AsyncStorage.getAllKeys()
                    ];
                case 1:
                    return [
                        4,
                        _.apply(AsyncStorage, [
                            _state.sent().filter(function(k) {
                                return k.startsWith('usePersistedState');
                            })
                        ])
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _clearPersistedState.apply(this, arguments);
}
export function usePersistedState(key, initialState) {
    var _useState = _sliced_to_array(useState(!!INITIAL_VALUES[key]), 2), loading = _useState[0], setLoading = _useState[1];
    var _INITIAL_VALUES_key;
    var _useState1 = _sliced_to_array(useState((_INITIAL_VALUES_key = INITIAL_VALUES[key]) !== null && _INITIAL_VALUES_key !== void 0 ? _INITIAL_VALUES_key : initialState), 2), value = _useState1[0], setValue = _useState1[1];
    var initialValueRef = useRef(value);
    // We keep valueRef around because setValueWithPersistence needs to be able
    // to pass the most recent value if it's passed an updater function which
    // may be cached in a closure somewhere else
    var valueRef = useRef(value);
    useEffect(function() {
        var storageKey = getStorageKey(key);
        void AsyncStorage.getItem(storageKey).then(function(persistedValue) {
            if (persistedValue) {
                var decoded = typeof persistedValue === 'undefined' ? undefined : JSON.parse(persistedValue);
                setValue(decoded);
                INITIAL_VALUES[key] = decoded;
                valueRef.current = decoded;
            }
            setLoading(false);
        });
        if (!listeners[storageKey]) listeners[storageKey] = [];
        listeners[storageKey].push(function(newValue) {
            setValue(typeof newValue === 'undefined' ? initialValueRef.current : newValue);
        });
        return function() {
            listeners[storageKey] = listeners[storageKey].filter(function(cb) {
                return cb !== setValue;
            });
        };
    }, [
        key
    ]);
    var setValueWithPersistence = useCallback(function(newValueOrFunc) {
        var newValue = typeof newValueOrFunc === 'function' ? newValueOrFunc(valueRef.current) : newValueOrFunc;
        setPersistedState(key, newValue);
        INITIAL_VALUES[key] = newValue;
        valueRef.current = newValue;
    }, [
        key
    ]);
    return [
        value,
        setValueWithPersistence,
        loading
    ];
}
